module.exports = __webpack_public_path__ + "images/85b6d3d969392acec2db0b7023b29a5f-laptop-coffee.jpg";